<template>
  <div class="d-flex justify-center">
    <div class="main-card mt-3">
      <v-tabs v-model="tab">
        <v-tab v-if="$store.getters.isReviewer">Reviewed by me</v-tab>
        <v-tab @change="tabChangedToMyReviews()">Submitted by me</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <!-- Reviewer reviews -->
        <v-tab-item v-if="$store.getters.isReviewer">
          <v-row>
            <!-- ------------------------ Under review ------------------------ -->
            <v-col cols="12">
              <div class="text-overline ml-5">Under review</div>
              <!-- when loading  -->
              <v-row v-if="reviewerReviewsLoading" class="ma-3">
                <v-col cols="12" md="6" lg="6">
                  <v-skeleton-loader type="card"> </v-skeleton-loader>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-skeleton-loader type="card"> </v-skeleton-loader>
                </v-col>
              </v-row>
              <!-- when error -->
              <v-row v-if="!reviewerReviewsLoading && reviewerReviewsError">
                <v-col
                  cols="12"
                  class="d-flex justify-center align-center ma-0 pa-0"
                >
                  <v-icon x-large color="red darken-2">
                    mdi-information-slab-circle-outline
                  </v-icon>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex justify-center align-center ma-0 pa-0"
                >
                  {{ reviewerReviewsError }}
                </v-col>
              </v-row>
              <!-- when all ok -->
              <v-row
                v-if="!reviewerReviewsLoading && !reviewerReviewsError"
                class="mx-3 my-1"
              >
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  v-for="r in reviewerReviews"
                  v-bind:key="r.id"
                >
                  <v-card
                    color="white mt-0"
                    class="mb-5 mx-auto my-12"
                    :class="{
                      'left-border-orange': r.Tier === 1,
                      'left-border-blue': r.Tier === 5,
                      'left-border-purple': r.Tier === 10,
                    }"
                  >
                    <v-card-text>
                      <div class="d-flex">
                        <div
                          class="font-weight-bold"
                          :class="{
                            'orange--text': r.Tier === 1,
                            'blue--text': r.Tier === 5,
                            'purple--text': r.Tier === 10,
                          }"
                        >
                          {{ $consts.TIER_MAP.get(r.Tier).name }}
                        </div>
                        <div class="ml-auto">
                          {{ $utils.relativeTimeFromTs(r.LastActionTs) }}
                        </div>
                      </div>
                      <p class="text-h6 text--primary">{{ r.Email }}</p>
                      <v-row align="center" class="mx-0">
                        <v-rating
                          :value="r.ScoreOverall"
                          color="amber"
                          dense
                          half-increments
                          readonly
                          size="15"
                        >
                        </v-rating>
                        <!-- <div class="grey--text ms-2">{{ r.ScoreOverall }}</div> -->
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text :href="`/review?id=${r.Id}`"> Review </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-col cols="12" v-if="reviewerReviews.length === 0">
                  No reviews
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="ml-2 mr-2">
              <v-divider></v-divider>
            </v-col>
            <!-- ------------------------ Archived ------------------------ -->
            <v-col v-if="!showArchived">
              <div class="d-flex mb-2">
                <v-spacer></v-spacer>
                <v-btn plain @click="showArchivedClicked()">
                  Show archived
                </v-btn>
                <v-spacer></v-spacer>
              </div>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="showArchived">
              <div class="text-overline ml-5">Archived</div>
              <!-- when loading  -->
              <v-row v-if="pastReviewerRevLoading" class="ma-3">
                <v-col cols="12" md="6" lg="6">
                  <v-skeleton-loader type="card"> </v-skeleton-loader>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-skeleton-loader type="card"> </v-skeleton-loader>
                </v-col>
              </v-row>
              <!-- when error -->
              <v-row v-if="!pastReviewerRevLoading && pastReviewerRevError">
                <v-col
                  cols="12"
                  class="d-flex justify-center align-center ma-0 pa-0"
                >
                  <v-icon x-large color="red darken-2">
                    mdi-information-slab-circle-outline
                  </v-icon>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex justify-center align-center ma-0 pa-0"
                >
                  {{ pastReviewerRevError }}
                </v-col>
              </v-row>
              <!-- when all ok -->
              <v-row
                v-if="!pastReviewerRevLoading && !pastReviewerRevError"
                class="mx-3 my-1"
              >
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  v-for="r in pastReviewerRev"
                  v-bind:key="r.id"
                >
                  <v-card
                    color="white mt-0"
                    class="mb-5 mx-auto my-12"
                    :class="{
                      'left-border-orange': r.Tier === 1,
                      'left-border-blue': r.Tier === 5,
                      'left-border-purple': r.Tier === 10,
                    }"
                  >
                    <v-card-text>
                      <div class="d-flex">
                        <div
                          class="font-weight-bold"
                          :class="{
                            'orange--text': r.Tier === 1,
                            'blue--text': r.Tier === 5,
                            'purple--text': r.Tier === 10,
                          }"
                        >
                          {{ $consts.TIER_MAP.get(r.Tier).name }}
                        </div>
                        <div class="ml-auto">
                          {{ $utils.relativeTimeFromTs(r.LastActionTs) }}
                        </div>
                      </div>
                      <p class="text-h6 text--primary">{{ r.Email }}</p>
                      <v-row align="center" class="mx-0">
                        <v-rating
                          :value="r.ScoreOverall"
                          color="amber"
                          dense
                          half-increments
                          readonly
                          size="15"
                        >
                        </v-rating>
                        <!-- <div class="grey--text ms-2">{{ r.ScoreOverall }}</div> -->
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text :href="`/review?id=${r.Id}`"> View </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-col cols="12" v-if="pastReviewerRev.length === 0">
                  No reviews
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="d-flex mb-2">
                    <v-spacer></v-spacer>
                    <v-btn plain disabled>Load more</v-btn>
                    <v-spacer></v-spacer>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-tab-item>
        <!-- ------------------------ My reviews (submitted by me) ------------------------ -->
        <v-tab-item>
          <v-row>
            <!-- ------------------------ My reviews ------------------------ -->
            <v-col cols="12">
              <div class="text-overline ml-5">My reviews</div>
              <!-- when loading  -->
              <v-row v-if="userReviewsLoading" class="ma-3">
                <v-col cols="12" md="6" lg="6">
                  <v-skeleton-loader type="card"> </v-skeleton-loader>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-skeleton-loader type="card"> </v-skeleton-loader>
                </v-col>
              </v-row>
              <!-- when error -->
              <v-row v-if="!userReviewsLoading && userReviewsError">
                <v-col
                  cols="12"
                  class="d-flex justify-center align-center ma-0 pa-0"
                >
                  <v-icon x-large color="red darken-2">
                    mdi-information-slab-circle-outline
                  </v-icon>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex justify-center align-center ma-0 pa-0"
                >
                  {{ userReviewsError }}
                </v-col>
              </v-row>
              <!-- when all ok -->
              <v-row
                v-if="!userReviewsLoading && !userReviewsError"
                class="mx-3 my-1"
              >
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  v-for="r in userReviews"
                  v-bind:key="r.id"
                >
                  <v-card
                    color="white mt-0"
                    class="mb-5 mx-auto my-12"
                    :class="{
                      'left-border-orange': r.Tier === 1,
                      'left-border-blue': r.Tier === 5,
                      'left-border-purple': r.Tier === 10,
                    }"
                  >
                    <v-card-text>
                      <div class="d-flex">
                        <div
                          class="font-weight-bold"
                          :class="{
                            'orange--text': r.Tier === 1,
                            'blue--text': r.Tier === 5,
                            'purple--text': r.Tier === 10,
                          }"
                        >
                          {{ $consts.TIER_MAP.get(r.Tier).name }}
                        </div>
                        <div class="ml-auto">
                          <v-chip
                            :color="getChipColor(r.Status)"
                            text-color="white"
                            small
                          >
                            {{ getChipText(r.Status) }}
                          </v-chip>
                        </div>
                      </div>
                      <p class="text-h6 text--primary">
                        {{ r.ResumeFileName }}
                      </p>
                      <v-row align="center" class="mx-0">
                        {{ $utils.relativeTimeFromTs(r.LastActionTs) }}
                      </v-row>
                      <v-row
                        align="center"
                        class="mx-0"
                        v-if="r.Status === 'reviewed'"
                      >
                        <v-rating
                          :value="r.ScoreOverall"
                          color="amber"
                          dense
                          half-increments
                          readonly
                          size="15"
                        >
                        </v-rating>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text :href="`/review-status?reviewId=${r.Id}`">
                        View
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-col cols="12" v-if="userReviews.length === 0">
                  No reviews
                </v-col>
              </v-row>
              <v-row>
                <v-col><v-spacer></v-spacer></v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: null,
      reviewerReviewsLoading: true,
      reviewerReviewsError: "",
      reviewerReviews: [],
      showArchived: false,
      pastReviewerRevLoading: true,
      pastReviewerRevError: "",
      pastReviewerRev: [],
      userReviewsLoading: true,
      userReviewsError: "",
      userReviews: [],
    };
  },
  beforeCreate() {
    this.$utils.visit(this);
  },
  mounted() {
    this.loadReviewerReviews();
  },
  methods: {
    async loadReviewerReviews() {
      this.reviewerReviewsLoading = true;
      this.reviewerReviewsError = "";
      console.log("loadReviewerReviews()");
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/rec/getAssignedReviews",
          {}
        );
        this.reviewerReviews = resp;
      } catch (error) {
        this.reviewerReviewsError = error;
      } finally {
        this.reviewerReviewsLoading = false;
      }
    },
    async showArchivedClicked() {
      this.showArchived = true;
      await this.getPastReviews();
    },
    async getPastReviews() {
      try {
        this.pastReviewerRevLoading = true;
        this.pastReviewerRevError = "";
        var resp = await this.$utils.callBackendPost(
          this,
          "/rec/getArchivedReviews",
          {}
        );
        console.log("past reviews: " + JSON.stringify(resp));
        this.pastReviewerRev = resp;
      } catch (error) {
        this.pastReviewerRevError = error;
      } finally {
        this.pastReviewerRevLoading = false;
      }
    },
    async getUserReviews() {
      this.userReviewsLoading = true;
      this.userReviewsError = "";
      console.log("getUserReviews()");
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/api/getUserReviews",
          {}
        );
        this.userReviews = resp;
      } catch (error) {
        this.userReviewsError = error;
      } finally {
        this.userReviewsLoading = false;
      }
    },
    async tabChangedToMyReviews() {
      console.log("tabChangedToMyReviews()");
      if (this.userReviews.length === 0) {
        await this.getUserReviews();
      }
    },
    getChipColor(status) {
      if (status === "reviewed") {
        return "green";
      } else if (status === "inreview") {
        return "blue";
      } else if (status === "created") {
        return "orange";
      }
      return "grey";
    },
    getChipText(status) {
      if (status === "reviewed") {
        return "reviewed";
      } else if (status === "inreview") {
        return "in review";
      } else if (status === "created") {
        return "created";
      }
      return "unknown";
    },
  },
};
</script>

<style scoped>
.main-card {
  width: 100vw;
  max-width: 1200px;
}
.left-border-orange {
  border-left: 20px solid orange !important;
}
.left-border-blue {
  border-left: 20px solid blue !important;
}
.left-border-purple {
  border-left: 20px solid purple !important;
}
</style>
